import React from 'react'
import { Dialog, DialogContent, DialogActions, Typography, makeStyles } from '@material-ui/core'
import Controls from "../controls/Controls";
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme.spacing(2),
    },
    dialogTitle: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: red[600]
    },
    dialogContent: {
        textAlign: 'center'
    },
    dialogAction: {
        justifyContent: 'center'
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    }
}))

export default function ConfirmDialog(props) {

    const { confirmDialog, setConfirmDialog } = props;
    const classes = useStyles()

    return (
        <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="h5" className={classes.dialogTitle}>
                    {confirmDialog.title}
                </Typography>
                <Typography variant="subtitle2">
                    {confirmDialog.subTitle}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Controls.ButtonColor
                    text="Cancel"
                    color="default"
                    onClick={!confirmDialog.onCancel ? () => setConfirmDialog({ ...confirmDialog, isOpen: false }) : () => confirmDialog.onCancel()} />
                <Controls.ButtonDanger
                    text="Continue"
                    color="default"
                    onClick={confirmDialog.onConfirm} />
            </DialogActions>
        </Dialog>
    )
}
